<template>
  <div class="mobile-filters-wrapper">
    <el-collapse v-model="activeNames">
      <el-collapse-item :title="$t('common.search_trainers_filters')" name="1">
        <div class="indent-wrapper">
          <SportTypeClub class="mt-3" />
          <District class="mt-2" />
          <MobileFilterSubway class="mt-2" />

          <Gender class="mt-2" />

          <Age class="mt-2" />
          <Cost class="mt-2" />
          <Schedule class="mt-2 mb-3" />
          <el-checkbox v-model="isChecked" @change="handleChange">
            {{ $t('common.outreach_training') }}
          </el-checkbox>

          <button
            class="button accent-button fz-18 mt-3"
            @click="searchTrainers"
          >
            {{ $t('common.find_a_trainer') }}
          </button>
          <button class="button reset-button fz-18 mt-3" @click="handleReset">
            {{ $t('common.reset') }}
          </button>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Gender from '~/components/Search/MobileFilters/Gender'
import SportTypeClub from '~/components/Search/MobileFilters/SportTypeClub'
import District from '~/components/Search/MobileFilters/MobileFiltersDistrict'
import MobileFilterSubway from '~/components/Search/MobileFilters/MobileFilterSubway'
import Age from '~/components/Search/MobileFilters/Age'
import Cost from '~/components/Search/MobileFilters/Cost'
import Schedule from '~/components/Search/MobileFilters/Schedule'

export default {
  name: 'MobileFilters',
  components: {
    Gender,
    SportTypeClub,
    District,
    MobileFilterSubway,
    Age,
    Cost,
    Schedule
  },
  data() {
    return {
      activeNames: [],
      isChecked: false
    }
  },
  computed: {
    ...mapGetters({
      checked: 'search/searchOutdoor',
      club: 'search/searchSportClub',
      sport: 'search/searchSportType'
    }),
    getUrl() {
      return this.club || this.sport
        ? `${(this.club || this.sport).type}/${(this.club || this.sport).url}`
        : ''
    }
  },
  mounted() {
    this.isChecked = this.checked
  },
  methods: {
    ...mapActions({
      setOutdoor: 'search/SET_OUTDOOR',
      resetFilters: 'search/RESET_FILTERS',
      clearCachedTrainers: 'search/CACHE_TRAINERS'
    }),
    handleChange() {
      this.setOutdoor(this.isChecked)
    },
    searchTrainers() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })

      //  clear cached trainers here
      this.clearCachedTrainers(null)

      this.$bus.$emit('clearList')
      this.activeNames = []

      this.$router.push({
        params: {
          pathMatch: this.getUrl,
          0: ''
        },
        query: {
          ...this.$route.query
        }
      })
    },
    handleReset() {
      this.resetFilters()
      //  clear list of trainers and load new
      this.$bus.$emit('clearList')
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/variables.scss';

.mobile-filters-wrapper {
  background-color: white;
}
.indent-wrapper {
  padding: 0 12px;
}

.reset-button {
  max-width: none;
  font-weight: normal;
}
</style>
